import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import classNames from 'classnames';
import Container from '../Utils/Container/Container';
import Subtitle from '../Subtitle/Subtitle';
import Heading, { HeadingTypes } from '../Heading/Heading';
import { ButtonSize } from '../../interfaces/enums/ButtonSize.enum';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import RichText from '../RichText/RichText';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import SbImage from '../SbImage/SbImage';

interface BlogCardProps {
  blok: {
    heading?: string;
    body?: StoryblokRichtext;
    cta?: Blok[];
    image?: StoryblokAsset;
  };
}

const BlogCard: React.FC<BlogCardProps> = ({ blok }) => {
  const { heading, body, cta, image } = blok;
  return (
    <div className={classNames('sm:flex gap-x-10 text-left bg-system/white')}>
      <div className="min-w-[200px]">
        {image?.filename && (
          <SbImage
            asset={image}
            options={{
              width: 800,
              objectFit: 'cover',
              sizes: { base: 500, sm: 769, xl: 689, xxl: 868 },
            }}
          />
        )}
      </div>
      <div className="flex flex-col gap-y-2 py-6 sm:py-8 px-6 sm:pr-10 sm:pl-0">
        {heading && <p className="font-bold text-xl">{heading}</p>}
        {body && <RichText content={body} />}

        {cta?.map((cta_item: Blok) => (
          <div className="w-full sm:w-auto" key={cta_item._uid}>
            <StoryblokComponent blok={{ ...cta_item, size: ButtonSize.XL }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(BlogCard);
